import { Mark, mergeAttributes } from '@tiptap/core';
import { POST_EDITOR_FONT_CLASS_VALUES, findFontClass } from '../lib/post_editor_constants.js';

export const FontFamilyClassExtension = Mark.create({
  name: 'fontFamilyClass',

  addAttributes() {
    return {
      fontFamilyClass: {
        default: null,
        parseHTML: element => findFontClass(element.getAttribute('class')),
        renderHTML: attributes => {
          return {
            class: attributes.fontFamilyClass || null,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[class*="font-"]',
      },
      {
        tag: 'p[class*="font-"]',
      },
      {
        tag: 'div[class*="font-"]',
      },
      {
        tag: 'td[class*="font-"]',
      },
      {
        tag: 'th[class*="font-"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes), 0];
  },

  addCommands() {
    return {
      setFontFamilyClass: className => ({ commands }) => {
        return commands.setMark(this.name, { fontFamilyClass: className });
      },
      unsetFontFamilyClass: () => ({ commands }) => {
        return commands.unsetMark(this.name);
      },
    };
  },
});
